var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperE(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 63,
    viewBox: "0 0 39 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.41113 1.59009H4.16113V0.0900879H0.911133V3.34009H2.41113V1.59009ZM0.911133 10.8401H2.41113V15.5301H0.911133V10.8401ZM2.41113 23.0201H0.911133V27.7101H2.41113V23.0201ZM3.71094 30.5901H6.21094V32.0901H3.71094V30.5901ZM11.9414 30.5901H16.0414V32.0901H11.9414V30.5901ZM31.6113 30.5901H34.1113V32.0901H31.6113V30.5901ZM25.8812 30.5901H21.7812V32.0901H25.8812V30.5901ZM38.8809 61.3301H36.3809V62.8301H38.8809V61.3301ZM11.7412 61.3301H16.4812V62.8301H11.7412V61.3301ZM28.8015 61.3301H24.0615V62.8301H28.8015V61.3301ZM0.911133 59.5801H2.41113V61.3301H4.16113V62.8301H0.911133V59.5801ZM2.41113 47.3901H0.911133V52.0801H2.41113V47.3901ZM0.911133 35.2101H2.41113V39.9001H0.911133V35.2101ZM11.7412 0.0900879H16.4812V1.59009H11.7412V0.0900879ZM28.8015 0.0900879H24.0615V1.59009H28.8015V0.0900879ZM36.3809 0.0900879H38.8809V1.59009H36.3809V0.0900879Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperE);
export default __webpack_public_path__ + "static/media/UPPER_E.0a87b8095305c751c61f596cbdec08b3.svg";
export { ForwardRef as ReactComponent };